<template>
    <div class="TrackTicket">
        <div class="sub-menu-section">
            <div class="sub-menu-bar-wrapper">
                <div class="sub-menu-bar">
                    <div class="sub-menu-bar-link cursor-pointer" @click="switchTicketTrackComponents('OPEN_TICKETS')" :class="{'active-sub-menu-link' : active_subMenu_link == 'OPEN_TICKETS'}">
                        Open Tickets
                    </div>
                    <div class="sub-menu-bar-link cursor-pointer" @click="switchTicketTrackComponents('CLOSED_TICKETS')" :class="{'active-sub-menu-link' : active_subMenu_link == 'CLOSED_TICKETS'}">
                        Closed Tickets
                    </div>
                </div>
            </div>
        </div>

        <div v-if="active_subMenu_link == 'OPEN_TICKETS'">
            <div v-loading="open_ticket_list_loading" class="top-margin-20">
                <div v-for="(ticket, open_ticket_index) in open_ticket_list" :key="open_ticket_index" class="flex ticket-details flex">
                    <div>
                        <div class="title"><span class="capitalize">{{ ticket.subject }}</span> #{{ ticket.ticket_number }}</div>
                        <div class="sub-title">Created on {{ moment(ticket.created_date).format('DD MMM YYYY HH:mm') }}</div>
                    </div>
                </div>
            </div>

            <NoDataFound v-if="!open_ticket_list.length && !open_ticket_list_loading"></NoDataFound>

            <el-pagination
                v-if="open_ticket_total_entries > 3 && open_ticket_list.length"
                class="label-xs-bold text-center top-margin-10 pagination"
                small
                :current-page.sync="open_ticket_current_page_no"
                :page-size="open_ticket_entries_per_page"
                layout="prev, pager, next"
                :total="open_ticket_total_entries"
                @current-change="handleCurrentPageChange">
            </el-pagination>
        </div>

        <div v-if="active_subMenu_link == 'CLOSED_TICKETS'">
            <div v-loading="closed_ticket_list_loading" class="top-margin-20">
                <div v-for="(ticket, closed_ticket_index) in closed_ticket_list" :key="closed_ticket_index" class="ticket-details flex">
                    <span><i class="el-icon-success"></i></span>
                    <div class="left-margin-15">
                        <div class="title"><span class="capitalize">{{ ticket.subject }}</span> #{{ ticket.ticket_number }}</div>
                        <div class="sub-title">Created on {{ moment(ticket.created_date).format('DD MMM YYYY HH:mm') }}</div>
                    </div>
                </div>
            </div>

            <NoDataFound v-if="!closed_ticket_list.length && !closed_ticket_list_loading"></NoDataFound>

            <el-pagination
                v-if="closed_ticket_total_entries > 3 && closed_ticket_list.length"
                class="label-xs-bold text-center top-margin-10 pagination"
                small
                :current-page.sync="closed_ticket_current_page_no"
                :page-size="closed_ticket_entries_per_page"
                layout="prev, pager, next"
                :total="closed_ticket_total_entries"
                @current-change="handleCurrentPageChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { serverAddr, serverAddrToUploadMediaFiles, serverHostName } from "../networkConfig";
import NoDataFound from "@/components/NoDataFound.vue";
import moment from 'moment';

export default {
    name: 'TrackTicket',
    components: {
        NoDataFound
    },
    data() {
        return {
            active_subMenu_link: 'OPEN_TICKETS',
            open_ticket_list: [],
            closed_ticket_list: [],
            open_ticket_list_loading: false,
            closed_ticket_list_loading: false,

            open_ticket_current_page_no: 1,
            open_ticket_entries_per_page: 3,
            open_ticket_total_entries: null,

            closed_ticket_current_page_no: 1,
            closed_ticket_entries_per_page: 3,
            closed_ticket_total_entries: null,
            moment: moment
        }
    },

    mounted() {
        this.getOpenTicketList();
    },

    methods: {
        // function called on pagination change
        handleCurrentPageChange(val){
            if(this.active_subMenu_link == 'OPEN_TICKETS'){
                this.open_ticket_current_page_no = val;     //assigned change page number
                this.getOpenTicketList();
            }else if(this.active_subMenu_link = 'CLOSED_TICKETS'){
                this.closed_ticket_current_page_no = val;    //assigned change page number
                this.getClosedTicketList();
            }
        },

        switchTicketTrackComponents(type){
            if(type == 'OPEN_TICKETS'){
                this.active_subMenu_link = 'OPEN_TICKETS';
                this.getOpenTicketList();
            }else{
                this.active_subMenu_link = 'CLOSED_TICKETS';
                this.getClosedTicketList();
            }
        },

        getOpenTicketList(){
            this.open_ticket_list_loading = true;     //enabled loader
            serverAddr
            .post("/support/get_user_ticket/", {
                status: "IN",
                page_per_entries: this.open_ticket_entries_per_page,
                page_number: this.open_ticket_current_page_no
            })
            .then((response)=>{
                if(response.data.status){
                    this.open_ticket_list = response.data.data;
                    this.open_ticket_current_page_no = response.data.pagination.current_page;
                    this.open_ticket_total_entries = response.data.pagination.total_entries;
                }
                this.open_ticket_list_loading = false;     //disabled loader
            })
            .catch(function(error) {
                console.log(error);
                this.open_ticket_list_loading = false;     //disabled loader
            }.bind(this));
        },

        getClosedTicketList(){
            this.closed_ticket_list_loading = true;     //enabled loader
            serverAddr
            .post("/support/get_user_ticket/", {
                status: "CL",
                page_per_entries: this.closed_ticket_entries_per_page,
                page_number: this.closed_ticket_current_page_no
            })
            .then((response)=>{
                if(response.data.status){
                    this.closed_ticket_list = response.data.data;
                    this.closed_ticket_current_page_no = response.data.pagination.current_page;
                    this.closed_ticket_total_entries = response.data.pagination.total_entries;
                }
                this.closed_ticket_list_loading = false;     //disabled loader
            })
            .catch(function(error) {
                console.log(error);
                this.closed_ticket_list_loading = false;     //disabled loader
            }.bind(this));
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
.TrackTicket{
    .sub-menu-section{
        position: unset;
    }
    .sub-menu-bar-wrapper {
      justify-content: space-between;
    }
    .NoDataFound{
        padding: 20px 0 0 0;
    }

    .ticket-details{
        padding: 12px;
        border-bottom: 1px solid #eee;
        i{
            font-size: 1.8rem;
            color: #33bb6d;
        }
        .title{
            font-size: 0.9rem;
            font-weight: 600;
            color: #000;
        }
        .sub-title{
            font-size: 0.7rem;
            margin-top: 3px;
            color: #979797;
        }
    }
    .pagination{
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        width: 100%;
    }
}
</style>
